import {
	deepCloneObject,
	lookupMessageKey,
	updateObject,
} from '../../../../../store/utility';

export const initialState = {
	searchUsers: [],
	searchUsersFiltered: [],
	roleString: null,
	error: null,
	loading: false,
	messages: [],
};

export const actionTypes = {
	ADD_MESSAGE: 'addMessage',
	CLEAR_MESSAGES: 'clearMessages',
	CLEAR_RESULTS: 'clearResults',
	FILTER_RESULTS: 'filter',
	SEARCH_FAILURE: 'searchFailure',
	SEARCH_START: 'searchStart',
	SEARCH_SUCCESS: 'searchSuccess',
};

export const reducer = (state, action) => {
	switch (action.type) {
		//Display a message
		case actionTypes.ADD_MESSAGE:
			const messageKeyId = action.payload.Key;
			const messageKey = lookupMessageKey(messageKeyId);
			let messageDetails = action.payload.Value;

			let newMessages = [...state.messages];
			if (!(newMessages && newMessages.length > 0)) {
				newMessages = [];
			}
			newMessages.push({
				type: messageKey,
				text: messageDetails,
			});

			window.scrollTo({ top: 0, behavior: 'auto' });

			return updateObject(state, {
				messages: newMessages,
			});
		//remove all messages
		case actionTypes.CLEAR_MESSAGES:
			return updateObject(state, {
				messages: [],
			});
		//remove all search results
		case actionTypes.CLEAR_RESULTS:
			return updateObject(state, {
				searchUsers: [],
				searchUsersFiltered: [],
				error: null,
				loading: false,
			});
		//apply filter to search results based on user input
		case actionTypes.FILTER_RESULTS:
			const filter = action.payload ? action.payload.toLowerCase() : '';
			let searchUsersCopy = deepCloneObject(state.searchUsers);
			searchUsersCopy = searchUsersCopy.filter(model =>
				model.Cells['Name'].Value.toLowerCase().includes(filter)
			);

			return updateObject(state, {
				searchUsersFiltered: searchUsersCopy,
			});
		//respond to a search failure
		case actionTypes.SEARCH_FAILURE:
			return updateObject(state, {
				searchUsers: [],
				searchUsersFiltered: [],
				error: action.payload,
				loading: false,
			});
		//search invoked
		case actionTypes.SEARCH_START:
			return updateObject(state, {
				searchUsers: [],
				searchUsersFiltered: [],
				error: null,
				loading: true,
			});
		//search results received
		case actionTypes.SEARCH_SUCCESS:
			return updateObject(state, {
				searchUsers: action.payload,
				searchUsersFiltered: action.payload,
				error: null,
				loading: false,
			});
		default:
			return state;
	}
};
